module.exports = __webpack_public_path__ + "img/wx-pay.633a9a03.jpg";